import React, { useEffect, useRef, useState } from "react";

const AppUpdateNotifier = () => {
  const [showUpdate, setShowUpdate] = useState(false);
  const currentTimestamp = useRef<string | null>(null);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const response = await fetch("/version.json", { cache: "no-cache" });
        const data = await response.json();
        const latestTimestamp = data?.timestamp?.toString().trim();

        if (
          currentTimestamp.current &&
          latestTimestamp !== currentTimestamp.current
        ) {
          setShowUpdate(true);
        } else {
          currentTimestamp.current = latestTimestamp;
        }
      } catch (error) {
        console.error("⚠️ Version check failed:", error);
      }
    };

    checkVersion(); // initial
    const interval = setInterval(checkVersion, 10000); // check every 10 seconds
    return () => clearInterval(interval);
  }, []);

  if (!showUpdate) return null;

  return (
    <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-50" style={{ zIndex: 9999 }}>
      <div className="card shadow border-0" style={{ maxWidth: "400px", width: "100%" }}>
        <div className="card-body text-center">
          {/* Icon */}
          <div className="mb-3">
     <i className="bx bxs-rocket text-dark fs-1"></i>

          </div>

          {/* Heading & Message */}
          <h5 className="card-title text-secondary">New Version Available</h5>
          <p className="card-text text-muted">Please reload the page to get the latest updates.</p>

          {/* Button */}
          <button
            className="btn btn-dark mt-3"
            onClick={() => window.location.replace(window.location.href)}
          >
            Refresh Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppUpdateNotifier;
